import React, { Component } from 'react'
import { withStyles } from '@material-ui/core';
import UsernameRegistration from './StepOne/UsernameRegistration';

const styles = theme => ({

})

class ReRegistrationLanding extends Component {
    render() {
        let { classes } = this.props;
        return (
            <div>
                <UsernameRegistration
                    history={this.props.history}
                />
            </div>
        )
    }
}

export default withStyles(styles)(ReRegistrationLanding)


// WEBPACK FOOTER //
// ./src/Components/ReRegistration/ReRegistrationLanding.js